import React, { useState, useEffect } from 'react';
import { useRouter } from "next/router";
import { useJitsu } from "@jitsu/jitsu-react";
import { useUserSessionControls } from "../../lib/context";
import { Menu } from "antd";
import { userProfileMenuLinks } from "./NavItems";
import { useTheme } from "../../components/ThemeContext/ThemeContext";
import ChangeThemeIcon from "../../public/images/menu/ChangeThemeIcon";
import ServicesIcon from "../../public/images/menu/ServicesIcon";
import LogoutIcon from "../../public/images/menu/LogoutIcon";

export const getCookie = (name: any) : string| undefined =>  {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift();
  return undefined;
}

const UserProfileNavDrawer = ({ user }) => {
  const router = useRouter();
  const { analytics } = useJitsu();
  const sessionControl = useUserSessionControls();
  const { darkMode, toggleDarkMode } = useTheme();
  const [uuiAppId, setUuiAppId] = useState<string | null>(null);

  useEffect(() => {
    const appId = getCookie("uuiAppId");
    setUuiAppId(appId ?? null);
  }, []);

  console.log("uuiAppId", uuiAppId);

  const handleMenuItemClick = (href, onClick) => {
    if (href) {
      window.open(href, '_blank');
    } else if (onClick) {
      onClick();
    }
  };

  const handleThemeToggle = () => {
    toggleDarkMode();
  };

  const renderMenuItem = (item: typeof userProfileMenuLinks[0], index: number) => {
    const IconComponent = item.icon;
    let href = item.href;
    if (uuiAppId && (item.id == "settings")) {
      href = `${href}/apps/${uuiAppId}/settings`;
    }
    if (uuiAppId && (item.id == "account")) {
      href = `${href}/apps/${uuiAppId}/account`;
    }
    return (
      <React.Fragment key={item.id}>
        <Menu.Item
          onClick={() => handleMenuItemClick(href, item.onClick)}
          className="border-subtle !p-4 w-full group flex items-center text-xs leading-5 text-gray-700 dark:text-gray-200"
        >
          <IconComponent width={20} height={20} className="inline" />
          <span className="text-base text-[var(--graph8-text)] pl-4 font-light dark:font-light">
            {item.title}
          </span>
        </Menu.Item>
        {item.addDivider && <Menu.Divider />}
      </React.Fragment>
    );
  };

  return (
    <div className="z-10 origin-top-right absolute right-0 w-56 rounded-md shadow-lg bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-800 focus:outline-none">
      <Menu className="menu">
        {userProfileMenuLinks.map((item, index) => renderMenuItem(item, index))}
        <Menu.Item
          onClick={handleThemeToggle}
          className="border-subtle !p-4 w-full group flex items-center px-4 py-3 text-xs leading-5"
        >
					<ChangeThemeIcon width={20} height={20} className="inline" />
          <span className="text-base self-start text-[var(--graph8-text)] pl-4">
            Change theme
          </span>
        </Menu.Item>
        <Menu.Item
          onClick={() => handleMenuItemClick("https://app.graph8.com/settings/services", null)}
          className="border-subtle !p-4 w-full group flex items-center px-4 py-3 text-xs leading-5"
        >
					<ServicesIcon width={20} height={20} className="inline" />
          <span className="text-base self-start text-[var(--graph8-text)] pl-4">
            Services
          </span>
        </Menu.Item>
        <Menu.Item
          onClick={async () => {
            await sessionControl.logout();
            analytics.reset();
            router.push("/", undefined, { shallow: true });
          }}
          className="border-subtle !p-4 w-full group flex items-center px-4 py-3 text-xs leading-5"
        >
          <LogoutIcon width={20} height={20} className="inline" />
          <span className="text-base self-start text-[var(--graph8-text)] pl-4">
            Sign Out
          </span>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default UserProfileNavDrawer;
